import { Check } from "lucide-react";

export function ChipSelect({ options, value = [], onChange, single = false, testid }) {
  const selected = single ? (value ? [value] : []) : value;

  const toggle = (opt) => {
    if (single) {
      onChange(value === opt ? null : opt);
      return;
    }
    onChange(selected.includes(opt) ? selected.filter((v) => v !== opt) : [...selected, opt]);
  };

  return (
    <div className="flex flex-wrap gap-2" data-testid={testid}>
      {options.map((opt) => {
        const active = selected.includes(opt);
        return (
          <button
            key={opt}
            type="button"
            onClick={() => toggle(opt)}
            data-testid={`chip-${opt.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className={`inline-flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 text-sm font-medium transition-all ${
              active
                ? "border-accent bg-accent/10 text-accent shadow-sm"
                : "border-border bg-surface text-muted-foreground hover:border-accent/40 hover:text-foreground"
            }`}
          >
            {active && <Check className="h-3 w-3" />}
            {opt}
          </button>
        );
      })}
    </div>
  );
}
